<template>
  <!-- basic modal -->
  <b-modal
    id="create-report-modal"
    :title="$t('create_reports')"
    size="md"
    :no-close-on-backdrop="true"
    cancel-variant="outline-secondary"
    cancel-title="Cancel"
    ok-title="Create"
    :ok-disabled="reports.length === 0"
    @hidden="resetModal"
    @ok="createReports"
  >
    <b-form
      ref="form"
      @submit.stop.prevent="handleSubmit"
    >
      <b-row>
        <b-col cols="12">
          <b-row
            ref="row"
          >
            <b-col md="3">
              <b-form-group
                label="Start"
                label-for="start"
              >
                <flat-pickr
                  v-model="startStr"
                  class="form-control"
                  :config="{ time_24hr: true }"
                  @on-change="(date) => { setDate(date, 'start') }"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="End"
                label-for="end"
              >
                <flat-pickr
                  v-model="endStr"
                  class="form-control"
                  :config="{ minDate: start, time_24hr: true }"
                  @on-change="(date) => { setDate(date, 'end') }"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Status"
                label-for="status"
              >
                <v-select
                  v-model="selectedStatus"
                  :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                  :options="statusOptions"
                  :clearable="false"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                block
                variant="outline-primary"
                style="margin-top: 6px;"
                :disabled="loading || !start || !end"
                @click="fetchAreasForReport"
              >
                Fetch
              </b-button>
            </b-col>
            <b-col cols="12">
              <hr>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row
        v-for="(report, index) in reports"
        :key="report.id"
        class="mt-1"
      >
        <b-col
          md="7"
          style="text-transform: capitalize"
        >
          <span>
            {{ report.name }}
          </span>
        </b-col>
        <b-col
          md="4"
        >
          <span>
            {{ report.total_shifts || 0 }} Shifts
          </span>
        </b-col>
        <b-col
          md="1"
        >
          <feather-icon
            size="16"
            icon="XCircleIcon"
            class="cursor-pointer"
            @click="removeItem(index)"
          />
        </b-col>
      </b-row>
      <b-row
        v-if="loading"
        style="justify-content: center;"
      >Loading...</b-row>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BButton, BModal, BRow, BCol, BFormGroup, BForm,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

export default {
  components: {
    BButton,
    BModal,
    BRow,
    BCol,
    BFormGroup,
    BForm,
    flatPickr,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      processer: null,
      loading: false,
      start: null,
      end: null,
      startStr: '',
      endStr: '',
      reports: [
      ],
      selectedStatus: {
        label: this.$t('completed'),
        value: 'completed',
      },
      statusOptions: [
        {
          label: this.$t('open'),
          value: 'open',
        },
        {
          label: this.$t('booked'),
          value: 'booked',
        },
        {
          label: this.$t('report_verified'),
          value: 'verified',
        },
        {
          label: this.$t('not_completed'),
          value: 'expired',
        },
        {
          label: this.$t('completed'),
          value: 'completed',
        },
      ],
    }
  },
  beforeCreate() {
    this.$store.dispatch('appAuth/getCurrentUser')
      .then(res => {
        const user = JSON.parse(JSON.stringify(res))
        this.processer = {
          firstName: user.firstName,
          lastName: user.lastName,
        }
      })
  },
  methods: {
    resetModal() {
      this.start = null
      this.end = null
      this.startStr = ''
      this.endStr = ''
      this.reports = []
      this.selectedStatus = {
        label: this.$t('completed'),
        value: 'completed',
      }
    },
    setDate(date, slot) {
      if (slot === 'start') {
        [this.start] = date
      }
      if (slot === 'end') {
        [this.end] = date
        this.end.setHours(23, 59, 59, 0)
      }

      if (this.end < this.start) {
        this.end = null
        this.endStr = ''
      }
    },
    fetchAreasForReport() {
      if (this.start && this.end && this.start < this.end && this.selectedStatus.value) {
        this.loading = true
        this.reports = []
        this.$emit('fetch-areas-for-report', {
          start: this.start.toISOString(),
          end: this.end.toISOString(),
          status: this.selectedStatus.value,
          callback: data => {
            this.reports = data.map(report => ({
              ...report,
              createdBy: `${this.processer.firstName} ${this.processer.lastName}`,
            }))
            this.loading = false
          },
        })
      } else {
        this.reports = []
      }
    },
    removeItem(index) {
      this.reports.splice(index, 1)
    },
    createReports() {
      if (this.reports.length > 0) {
        this.$emit('create-reports', {
          reports: this.reports,
          start: this.start.toISOString(),
          end: this.end.toISOString(),
          status: this.selectedStatus.value,
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@hw-ui/scss/vue/libs/vue-flatpicker.scss';
.row {
  align-items: center;
}
.modal-dialog {
  max-width: 750px;
}
</style>
